<template>
    <div class="function" :style="'background:url('+indata.bgcImage+') no-repeat 50% 50%'" >
    	<div class="title">{{ indata.FirstTitle }}</div>
        <h6>{{ indata.subTitle }}</h6>
        <div class="box">
        
            <span class="box01" style="margin-left:64px;vertical-align:top;margin-top:40px;" v-for="(item, index) in indata.children" :key="index">
              <div class="img"> <img :src="item.image" alt="" /></div>
                  <h2>{{ item.title }}</h2>
              <h4>{{ item.introduce }}</h4>
            </span>
        </div>
    </div>
</template>

<style scoped src="../../public/css/icould.css">
</style>

<script>
export default {
  name: "Templates26",
  props:{
    indata:Array
  },
  data(){
    return{
      NowIndex:0
    }
  }
  ,
  methods :{
changeActive(index){
  this.NowIndex=index
}
  }
};
</script>
